/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import isEmpty from 'lodash/isEmpty';

export const filterComboboxItems = ({
  item,
  itemToString,
  inputValue,
}: {
  item: unknown; // really can be any value
  itemToString: (item: unknown) => string; // TODO: how do I make this a function type that takes any as an argument but always returns a string
  inputValue: string;
}): boolean =>
  isEmpty(inputValue) || !itemToString
    ? true
    : itemToString(item)
        ?.toLowerCase()
        ?.includes(inputValue?.toLowerCase());
